import { Flex, Select, Text } from "@mantine/core";
import { ReactElement, useEffect, useState } from "react";
import { ISelectHostingRegionProps } from "./types";
import { useConfig } from "@stores/config/hooks";

export default function SelectHostingRegion({
  "data-testid": dataTestid,
  ignoreList,
  defaultValue,
  value,
  onChange,
  ...styleProps
}: ISelectHostingRegionProps): ReactElement {
  const config = useConfig();
  const regions = config.regions
    .filter(
      ({ region, name }) =>
        !(ignoreList?.includes(region) || ignoreList?.includes(name)),
    )
    .map(({ region: value, name: label }) => ({
      value,
      label,
    }));

  const [theValue, setTheValue] = useState<string | null | undefined>();

  useEffect(() => {
    // If the value === ""
    // we pick the first region
    const isFirstRegion = value?.length === 0 && regions[0];
    const theRegion = isFirstRegion ? regions[0].value : value;
    if (isFirstRegion) {
      onChange?.(theRegion || null);
    }

    setTheValue(theRegion);
  }, [value, regions, onChange]);

  // Only 1 region
  if (regions.length === 1) {
    const [region] = regions;
    return (
      <Text fz="sm" m={0} p={0}>
        Only <b>{region.label}</b> is available at the moment
      </Text>
    );
  }

  return (
    <Flex
      align="center"
      direction="row"
      justify="flex-start"
      wrap="nowrap"
      w="100%"
      {...styleProps}
    >
      <Select
        data-testid={dataTestid}
        placeholder="Select one..."
        required
        data={regions}
        defaultValue={defaultValue}
        value={theValue}
        onChange={onChange}
        w="100%"
      />
    </Flex>
  );
}
